<template>
  <div class="all">
    <v-header title="资讯"></v-header>
    <!-- <div class="conH"></div> -->
    <div class="content" >
      <!-- <div class="zixun-tit">
                资&nbsp;讯
      </div>-->
      <!-- 公司内容开始 -->
      <!-- :tab-position="tabPosition" -->
      <el-tabs >
        <el-tab-pane label="公司">
          <div class="company">
            <ul class="zixunlist">
              <li v-if="imglist.length!=0">
                <div class="banner">
                  <el-carousel height="9rem">
                    <el-carousel-item v-for="img in imglist" :key="img.key">
                      <img :src="img.picUrl" @click="toURLParameter(img.pageUrl)">
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </li>
              <li v-for="(item,index) in items" :key="index">
                <div @click="toURLParameter(item.pageUrl)">
                  <div class="liimg">
                    <img :src="item.picUrl">
                  </div>
                  <div class="liword">
                    <label>{{item.title}}</label>
                    <div class="author_time">
                      <span class="author">{{item.publishPersion}}</span>
                      <span class="divider">|</span>
                      <span class="time">{{item.publishTime}}</span>
                    </div>                    
                    <div class="subTitle">{{item.subHeading}}</div>
                  </div>
                </div>
                
              </li>
            </ul>
            <div  v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
                <div v-show="loadingShow" class="loading">
                  <div class="demo0">加载中</div>
                  <div  id="loading1">
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                  </div>
                </div>
                <el-row>
                  <el-col :span="24" class="nodata" v-show="nodata">暂无数据</el-col>
                </el-row>
                <div v-show="line" class="line">
                <span>我是有底线的</span>
                </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 公司内容结束 -->
        <el-tab-pane label="渠道">
          <!-- <div class="listcon">渠道</div> -->
          <div class="qudao">
            <ul class="zixunlist">
              <li v-if="imglistChannel.length!=0">
                <div class="banner">
                  <el-carousel height="9rem">
                    <el-carousel-item v-for="img in imglistChannel" :key="img.key">
                      <img :src="img.picUrl" @click="toURLParameter(img.pageUrl)">
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </li>
              <li v-for="(item,index) in itemsChannel" :key="index">
                <!-- <router-link to="item.pageUrl"> -->
                  <div @click="toURLParameter(item.pageUrl)">
                  <div class="liimg">
                    <img :src="item.picUrl">
                  </div>
                  <div class="liword">
                    <label>{{item.title}}</label>
                    <span class="author">{{item.publishPersion}}</span><span class="divider">|</span><span class="time">{{item.publishTime}}</span>
                    <!-- <span class="time">{{item.publishTime}}</span> -->
                    <!-- <span class="word"></span> -->
                    <div class="subTitle">{{item.subHeading}}</div>
                  </div>
                  </div>

                <!-- </router-link> -->
                
              </li>
            </ul>
             <div  v-infinite-scroll="loadMore2" infinite-scroll-disabled="busy2" infinite-scroll-distance="10">
                <div v-show="loadingShow2" class="loading">
                  <div class="demo0">加载中</div>
                  <div  id="loading1">
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                  </div>
                </div>
                <el-row>
                  <el-col :span="24" class="nodata" v-show="nodata2">暂无数据</el-col>
                </el-row>
                <div v-show="line2" class="line">
                <span>我是有底线的</span>
                </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- 公司内容结束 -->
    </div>
    <!-- 置顶 -->
    <transition name="fade">
      <div class="return-top" id="return-top" v-show="returntop" @click="gotop">
        <img src="../../static/image/returntop.png">
      </div>
    </transition>
  </div>
</template>
<script>
import api from "@/modules/api.js";
import url from "@/modules/url.js";
import vHeader from "@/layout/Header1.vue";
let timer = null; // 定义初始值
export default {
  components: { vHeader },
  // name: '首页',
  data() {
    return {
      result: "",
      password: "",
      username: "",
      items: [],
      imglist: [],
      itemsChannel: [],
      imglistChannel: [],
      day: "",
      date: "",
      conbox: true,
      returntop: false,
      pageSize:7,
      pageNum:1,
      busy: true, //是否正在加载过程中,true为繁忙的时候不执行loadMore,false则执行
      loadingShow:false,//是否显示加载中提示文字
      line:false,
      nodata:false,
      pageNum2:1,
      busy2: true, //是否正在加载过程中,true为繁忙的时候不执行loadMore,false则执行
      loadingShow2:false,//是否显示加载中提示文字
      line2:false,
      nodata2:false,
      contentHeight:''

    };
  },
  computed: {},
  methods: {
    // 鼠标滚动
    changetime(data) {
      let getDate = new Date(data);
      let y = getDate.getFullYear();
      let M = getDate.getMonth() + 1;
      let d = getDate.getDate();
      let format = y + "-" + M + "-" + d;
      return format;
    },
    loadMore () {
      // alert(0)
      this.pageNum++
      this.initInformation(true);
    },
    loadMore2 () {
      // alert(3)
      this.pageNum2++
      this.initChannelInfo(true);
    },
    initInformation(flag) {
      let that = this;
      let msg = {
        pageSize: that.pageSize,
        pageNum: that.pageNum
      }
      api.initInformation(msg, res => {
        console.log(res);
        if (res.result.isSuccess === true) {
          // 新闻列表
          if(flag){
            // 多次加载数据
            that.items = that.items.concat(res.data.newsList)
              if(res.data.newsList.length == 0){
                  that.busy = true;
                  that.loadingShow = false
                  that.line = true
              }else{
                  that.busy = false;
                  that.loadingShow = true
                  that.line = false
              }

          }else{
            // 第一次加载数据
            // 轮播图
            let caroList = res.data.caroList;
            caroList.forEach(resimg => {
              that.imglist.push(resimg);
            });
            that.items = res.data.newsList            
              if(res.data.newsList.length<that.pageSize){
                // alert(1)
                //小于10条数据不滚动加载busy设为true
                // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
                that.busy = true
                that.line = true
                that.loadingShow = false
              }else{
                // alert(0)
                that.line = false
                that.loadingShow = true
                // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
                that.busy = false
              } 

          }
          if(res.data.totals == 0){
                that.nodata = true
                that.line= false
                // this.$toast.message("没有查到数据")
          }

          // let newslist = res.data.newsList;
          // console.log(newslist, "资讯新闻");
          // newslist.forEach(resData => {
          //   resData.publishTime = that.changetime(resData.publishTime);
          //   that.items.push(resData);
          // });
        }
      });
    },
    initChannelInfo(flag) {      
      let that = this;
      let msg = {
        pageSize: that.pageSize,
        pageNum: that.pageNum2
      }
      api.post(that.$url.initChannelInfo,msg,function(res){
        console.log(res);
        if (res.result.isSuccess === true) {
          // 新闻列表
          if(flag){
            // 多次加载数据
            that.itemsChannel = that.itemsChannel.concat(res.data.newsList)
              if(res.data.newsList.length == 0){
                  that.busy2 = true;
                  that.loadingShow2 = false
                  that.line2 = true
              }else{
                  that.busy2 = false;
                  that.loadingShow2 = true
                  that.line2 = false
              }

          }else{
            // 第一次加载数据
            // 轮播图
            let caroList = res.data.caroList
            caroList.forEach(resimg => {
              that.imglistChannel.push(resimg)
            });
            
            that.itemsChannel = res.data.newsList            
              if(res.data.newsList.length<that.pageSize){
                // alert(1)
                //小于10条数据不滚动加载busy设为true
                // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
                that.busy2 = true
                that.line2 = true
                that.loadingShow2 = false
              }else{
                // alert(0)
                that.line2 = false
                that.loadingShow2 = true
                // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
                that.busy2 = false
              } 

          }
          if(res.data.totals == 0){
                that.nodata2 = true
                that.line2= false
                // this.$toast.message("没有查到数据")
          }

          // let newslist = res.data.newsList
          // let caroList = res.data.caroList
          // caroList.forEach(resimg => {
          //   that.imglistChannel.push(resimg)
          // });
          // console.log(that.imglistChannel, "渠道轮播");
          // newslist.forEach(resData => {
          //   resData.publishTime = that.changetime(resData.publishTime)
          //   that.itemsChannel.push(resData)
          // });
        }
      })
    },
    handleScroll() {
      // var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var scrollTop = document.querySelector(".content").scrollTop;
      if (scrollTop > 200) {
        this.returntop = true;
      } else {
        this.returntop = false;
      }
    },
    gotop() {
      // document.querySelector('#main_div').animate({
      //     'scrollTop': 0
      // }, 'fast');
      // document.querySelector('#main_div').scrollTop=0
      var box = document.querySelector(".content");
      timer = setInterval(function() {
        let osTop = box.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        box.scrollTop = osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    toURLParameter(url){
      let that = this
      // alert(url)
      if (url === '') {
          that.$message('敬请期待')
      } else {
          if (url.slice(0, 4) === 'http') {
            // tempurl = url
            // window.location.href = tempurl
            window.open(url)
          }  else {
            if(url.slice(0, 1) === '/')
            {
              that.$router.push({path: url})
            }else{
              that.$router.push({path:'/' + url})
            }           
          }
      }
    }
  },
  mounted() {
    // this.contentHeight = document.querySelector('.el-main').clientHeight - 100 + 'px'
    this.initInformation(false);
    this.initChannelInfo(false)
    var mainDiv = document.querySelector(".content");
    mainDiv.addEventListener("scroll", this.handleScroll);
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     // 参数vm就是当前组件的实例。
  //     vm.check();
  //   });
  // }
};
</script>
<style scoped>
.all {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  /* background: #fff; */
}
ul,
li {
  list-style: none;
  padding-inline-start: 0px;
}
.content {
  width: 96%;
  height: calc(98% - 100px);
  margin: 0 auto;
  padding-top: 10px;
  background: #fff;
  margin-top: 2%;
  /* margin-bottom: 50px; */
  overflow: auto;
  box-sizing: border-box;
}
.content::-webkit-scrollbar{width: 2px;}
.content::-webkit-scrollbar-thumb{background:rgba(193,193,193, .4);}
/* .content::-webkit-scrollbar-thumb:hover{background-color:#bbb;} */
.zixun-tit {
  width: 100%;
  /* height: 40px;
  line-height: 40px; */
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-left: -14px;
  /* border-bottom: 1px solid #dfdfdf; */
}
.ul-title {
  /* width: 12%; */
  width: 100%;
  margin: auto;
  color: #111111;
  /* margin-top: 5px; */
  height: 50px;
}
.ul-title li {
  width: 45%;
  margin-left: 3%;
  float: left;
  font-size: 18px;
  font-weight: bold;
  padding: 12px 0px 8px 0px;
  /* margin: 0 20px; */
}
.li-one {
  text-align: right;
}
/* .li-two{text-align: left;} */
.ul-title li span {
  cursor: pointer;
}
.active span {
  border-bottom: 2px solid #194793;
  color: #194793;
}
.company,.qudao{
  padding-bottom:30px;
}
.zixunlist {
  width: 94%;
  height: auto;
  margin: 0 auto;
  clear: both;
  overflow: hidden;
}
.zixunlist li {
  /* display: inline-block; */
  float: left;
  width: calc(50% - 20px);
  /* margin-left: 20px; */
  padding: 20px 0;
  border-bottom: 1px solid #ededed;
  cursor: pointer;
}
.zixunlist li:nth-child(2n) {
  float: right;
  width: calc(50% - 20px);
}
.zixunlist li:last-child {
  border-bottom: none;
}
.zixunlist li:nth-last-child(2) {
  border-bottom: none;
}
.zixunlist li:first-child {
  border: none;
  padding-top: 10px;
}
.zixunlist li:nth-child(2) {
  padding-top: 10px;
}
.zixunlist li img {
  width: 100%;
  height: 100%;
}
.liimg {
  /* width: 12rem; */
  width: 50%;
  height: 9rem;
  display: inline-block;
}
.liimg img {
  width: 100%;
  height: 100%;
}
.liword {
  display: inline-block;
  padding-left: 2%;
  width: 45%;
  vertical-align: top;
}
.liword label {
  display: block;
  font-size: 16px;
  line-height: 25px;
  min-height: 50px;
  font-family: PingFang-SC-Medium;
  font-weight: 600;
  color: #194793;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.liword span{
  vertical-align: middle;
}
.author_time{
  margin-top: 10px;
}
.time {
  font-size: 14px;
  color: #999999;
  /* display: inline-block; */
  margin: 15px 0 6px 0;
}
.author{
  color: #999;
  font-size: 15px;
  /* overflow: hidden;
  text-overflow: ellipsis; */
  /* border-right: 1px solid #999999; */
}
.divider{
  color: #999;
  font-size: 12px;
  padding:0 2px;
}
.subTitle{
  color:#666;
  font-size: 14px;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
/* .word {
  color: #666666;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
} */
.banner {
  width: 100%;
}
/* tab切换 */
.listcon {
  padding: 20px;
}
.content >>> .el-tabs__nav {
  left: 50%;
  margin-left: -48px;
}
.content >>> .el-tabs__nav-wrap::after {
  background-color: transparent;
}
.content >>> .el-tabs__item {
  font-weight: 600;
  height: 30px;
  line-height: 30px;
  /* width: 45%;
  margin-left: 3%; */
}
.content >>> .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  text-align: right;
}
/* 返回顶部 */
.return-top {
  width: 80px;
  position: fixed;
  right: 30px;
  bottom: 20px;
}
.return-top img {
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}



.line{
  width: 100%;
  margin: auto;
  margin-top: 20px;
  border-top:1px solid #E5E5E5;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.line span{
  color: #E5E5E5;
  font-size: 12px;
  background:#fff;
  padding:0 2px;
  position: absolute;
  top:-8px;
}
.nodata{
  color: #666;margin-top: 20px; text-align: center;
}
.load-more-normal {
    text-align: center;
    height: 60px;
    line-height: 60px;
  }

  .load-more-hide {
    height: 0;
  }

  .loading{
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
.demo0{color:#ccc;font-size: 14px; float: left; margin-right: 6px;}
  .demo1 {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background: #ccc;
    float: left;
    margin: 0 3px;
    animation: demo1 linear 1s infinite;
    -webkit-animation: demo1 linear 1s infinite;
}
.demo1:nth-child(1){
    animation-delay:0s;
}
.demo1:nth-child(2){
    animation-delay:0.15s;
}
.demo1:nth-child(3){
    animation-delay:0.3s;
}
.demo1:nth-child(4){
    animation-delay:0.45s;
}
.demo1:nth-child(5){
    animation-delay:0.6s;
}
@keyframes demo1 
{
    0%,60%,100% {transform: scale(1);}
    30% {transform: scale(2.5);}
}
@-webkit-keyframes demo1 
{
    0%,60%,100% {transform: scale(1);}
    30% {transform: scale(2.5);}
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  /* .ul-title {
    width: 26% !important;
  } */
  .liword label {
    font-size: 14px !important;
  }
  .word {
    font-size: 12px !important;
  }
  .time {
    font-size: 10px !important;
  }
  .zixunlist li {
    width: 46% !important;
    margin-left: 2% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/message.vue